import {
  CREATING_BOOKING,
  UPDATING_BOOKING,
  BOOKING_CREATED,
  BOOKING_UPDATED,
  ERROR_BOOKING_CREATE,
  ERROR_BOOKING_UPDATE,
  UPDATED_RECENTLY,
  SET_UPDATED_RECENTLY_TO_FALSE
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const setUpdatedRecentlyToFalse = () => async (dispatch) => {
  dispatch({
    type: SET_UPDATED_RECENTLY_TO_FALSE,
  });
}

export const createEntity = (formData, tokenData, exitNow, history) => async (dispatch) => {
  dispatch({
    type: CREATING_BOOKING,
  });

  let webKitFormData = new FormData();
  Object.keys(formData).forEach((item, i) => {
    webKitFormData.append(item, formData[item])
  });

  await axios
    .post(`${BASE_URL}api/v1/admin/front/packagebooking/add`, webKitFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: BOOKING_CREATED,
        payload: response,
      });
      dispatch({
        type: UPDATED_RECENTLY,
      })      
      message.success(response.data.message);
      if (exitNow) {
        history.push("/bookings")
      }
    })
    .catch(function (error) {
      dispatch({
        type: ERROR_BOOKING_CREATE,
        payload: error.response,
      })
      message.error(error.response.data.message);
    });
};

export const updateEntityInfo = (formData, tokenData, id) => async (dispatch) => {
  dispatch({
    type: UPDATING_BOOKING,
  });

  let webKitFormData = new FormData();
  Object.keys(formData).forEach((item, i) => {
    webKitFormData.append(item, formData[item])
  });
  webKitFormData.append('_method', 'put')

  await axios
    .post(`${BASE_URL}api/v1/admin/front/packagebooking/${id}`, webKitFormData, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: BOOKING_UPDATED,
        payload: response,
      });
      dispatch({
        type: UPDATED_RECENTLY,
      })
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: ERROR_BOOKING_UPDATE,
        payload: error.response,
      })
      message.error(error.response.data.message);
    });
};
